
import { pages, subPackages, tabBar } from '@/pages.json'
import { useUserInfo } from '@/store/index'
import lib from '@/components/lib/index'
import route from '@/utils/route'
import { getSignature } from '@/service/base'
import dayjs from 'dayjs'
export const imgUrl = import.meta.env.VITE_IMAGE_URL
export const baseUrl = import.meta.env.VITE_SERVER_BASEURL
export const uploadUrl = import.meta.env.VITE_UPLOAD_BASEURL
export const $dayjs = dayjs
export const loginOut = () => {
  const userInfoStore = useUserInfo()
  userInfoStore.logout()
  let url = '/pages/login/navigation'
  uni.navigateTo({
    url,
  })
}

const getLastPage = () => {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包回报错，所以改用下面这个【虽然我加了src/interceptions/prototype.ts，但依然报错】
  // eslint-disable-next-line no-undef
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}
//退出登录跳转到登录页
export const gotoWxAuthorzation = () => {
  const userInfo = useUserInfo()
  userInfo.logout()
  uni.navigateTo({
    url: `/pages/login/index`,
  })
}

/** 判断当前页面是否是tabbar页  */
export const getIsTabbar = () => {
  if (!tabBar) {
    return false
  }
  if (!tabBar.list.length) {
    // 通常有tabBar的话，list不能有空，且至少有2个元素，这里其实不用处理
    return false
  }
  const lastPage = getLastPage()
  const currPath = lastPage.route
  return !!tabBar.list.find((e) => e.pagePath === currPath)
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 ‘/pages/login/index’
 * redirectPath 如 ‘/pages/demo/base/route-interceptor’
 */
export const currRoute = () => {
  const lastPage = getLastPage()
  const currRoute = lastPage.$page
  // console.log('lastPage.$page:', currRoute)
  // console.log('lastPage.$page.fullpath:', currRoute.fullPath)
  // console.log('lastPage.$page.options:', currRoute.options)
  // console.log('lastPage.options:', (lastPage as any).options)
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute
  // console.log(fullPath)
  // eg: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/login/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

const ensureDecodeURIComponent = (url) => {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/login/index, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export const getUrlObj = (url) => {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 这里设计得通用一点，可以传递key作为判断依据，默认是 needLogin, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的pages，如果传递了 key, 则表示通过 key 过滤
 */
export const getAllPages = (key = 'needLogin') => {
  // 这里处理主包
  const mainPages = [
    ...pages
      .filter((page) => !key || page[key])
      .map((page) => ({
        ...page,
        path: `/${page.path}`,
      })),
  ]
  // 这里处理分包
  const subPages = []
  subPackages.forEach((subPageObj) => {
    // console.log(subPageObj)
    const { root } = subPageObj

    subPageObj.pages
      .filter((page) => !key || page[key])
      .forEach((page) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  // console.log(`getAllPages by ${key} result: `, result)
  return result
}

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = () => getAllPages('needLogin').map((page) => page.path)

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needLoginPages = getAllPages('needLogin').map((page) => page.path)


export const navPage = (url, parameter) => {
  route(url, parameter)
}
/**
 * 处理富文本里的图片宽度自适应
 * 1.去掉img标签里的style、width、height属性
 * 2.img标签添加style属性：max-width:100%;height:auto
 * 3.修改所有style里的width属性为max-width:100%
 * 4.去掉
标签
*/
export const formatRichText = (html) => {
  let newContent = html
  newContent = newContent.replace(/<img[^>]*>/gi, function (match, capture) {
    match = match.replace(/(style="(.*?)")|(width="(.*?)")|(height="(.*?)")/gi, '')
    return match
  })
  /*   newContent = newContent.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/gi, '').replace(/style='[^']+'/gi, '')
  newContent = newContent.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
  newContent = newContent.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '') */
  newContent = newContent.replace(
    /<img/gi,
    '<img style="max-width:100% !important;height:auto !important;display:block;margin-top:0;margin-bottom:0;"'
  )
  newContent = formatRichTexts(newContent)
  return newContent
}
const formatRichTexts = (html) => {
  let newContent = html
  // eslint-disable-next-line no-useless-escape
  newContent = newContent.replace(/\<p/gi, '<p class="detail-content-p"')
  return newContent
}
//脱敏
export const desensitization = (str, type) => {
  if (lib.isEmpty(str)) {
    return ''
  }
  let reg = ''
  switch (type) {
    case 'phone':
      reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
      // eslint-disable-next-line no-case-declarations
      let phone = str.replace(reg, '$1****$2');
      return phone; // 185****6696
    case 'card':
      reg = /^(.{6})(?:\d+)(.{4})$/; // 匹配身份证号前6位和后4位的正则表达式
      // eslint-disable-next-line no-case-declarations
      const maskedIdCard = str.replace(reg, '$1******$2'); // 身份证号脱敏，将中间8位替换为“*”
      return maskedIdCard; // 输出：371782******5896
    case 'name':
      // eslint-disable-next-line no-case-declarations
      let name = str
      if (name.length == 2) {
        name = name.substring(0, 1) + '*'; // 截取name 字符串截取第一个字符，
        return name; // 张三显示为张*
      } else if (name.length == 3) {
        name = name.substring(0, 1) + '*' + name.substring(2, 3); // 截取第一个和第三个字符
        return name; // 李思思显示为李*思
      } else if (name.length > 3) {
        name = name.substring(0, 1) + '*' + '*' + name.substring(3, name.length); // 截取第一个和大于第4个字符
        return name; // 王五哈哈显示为王**哈
      }
  }

}

export const userHasPermission = (value) => {
  let permissionList = uni.getStorageSync('SYS_BUTTON_AUTH') || [];
  permissionList = permissionList.filter(item => item.type != '2');
  let permission = permissionList.map(item => {
    return item.action
  })
  if (!permission.includes(value)) {
    return false
  } else {
    return true
  }
}

/* export const getUrlParam = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
} */

export const browser = () => {
  const u = navigator.userAgent,
    app = navigator.appVersion;
  return {
    trident: u.indexOf("Trident") > -1, //IE内核
    presto: u.indexOf("Presto") > -1, //opera内核
    webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
    gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    ios11: !!u.match(/CPU iPhone OS [1][1]/i), //ios11终端
    android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
    iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("iPad") > -1, //是否iPad
    webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf("MicroMessenger") > -1, //是否微信
    qq: u.indexOf("MQQBrowser") > -1, //是否QQ
    app: u.indexOf("YjyApp") > -1 || u.indexOf("native_") > -1
  };
}

export const toWeiXinAuthLoginByUrl = (url) => {
  let href = url;
  href = `${encodeURIComponent(href)}`;
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${import.meta.env.VITE_WX_APPID}&redirect_uri=${href}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
};
export const isEmpty = (v) => {
  if (v == '') return true
  if (v == void 0) return true
  switch (typeof v) {
    case 'undefined':
      return true
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
      break
    case 'boolean':
      if (!v) return true
      break
    case 'number':
      if (isNaN(v)) return true
      break
    case 'object':
      if (null === v || v.length === 0) return true
      for (const i in v) {
        return i ? false : false
      }
      return true
  }
  return false
}

export const getOssSignature = () => {
  return new Promise((resolve, reject) => {
    console.log('图片上传执行')
    let OssSignature = uni.getStorageSync('OssSignature')
    if (isEmpty(OssSignature)) {
      var currentTime = Math.round(new Date().getTime() / 1000).toString() //当前时间戳
      console.log(
        OssSignature.expire > currentTime,
        '查看当前时间戳是否过期',
        OssSignature.expire,
        currentTime,
        OssSignature.expire > currentTime,
      )
      if (OssSignature.expire > currentTime) {
        resolve(OssSignature)
        return
      }
    }
    getSignature()
      .then((res) => {
        uni.setStorageSync('OssSignature', res.result)
        resolve(res.result)
      })
      .catch((err) => {
        reject(err)
        uni.hideLoading()
        toast(err)
      })
  })
}
export const aliOssUpload = async (file, publish = true) => {
  let config = await getOssSignature(publish);
  return new Promise((resolve, reject) => {
    console.log('图片上传执行')
    //获取签名
    let fileName = file.name
    const aliyunServerURL = publish ? config.publicHost : config.host;
    // 存储路径(后台固定位置+随即数+文件格式)
    const aliyunFileKey = `injection/${$dayjs().format('YYYYMM')}/${new Date().getTime() + Math.floor(Math.random() * 100) + fileName}`;
    console.log(aliyunFileKey, '查看上传的路径')
    // 临时AccessKeyID0
    const OSSAccessKeyId = config.accessid
    // 加密策略
    const policy = config.policy
    // 签名
    const signature = config.signature
    let filePath = file.path;
    //}
    //上传oss
    uni.uploadFile({
      url: aliyunServerURL,
      filePath: filePath,//要上传文件资源的路径
      name: 'file',//必须填file
      header: {

      },
      formData: {
        'key': aliyunFileKey,
        'policy': policy,
        'OSSAccessKeyId': OSSAccessKeyId,
        'signature': signature,
        'success_action_status': '200',
      },
      success: (res) => {
        console.log(res)
        if (res.statusCode != 200) {
          reject('上传错误:' + JSON.stringify(res))
          return;
        }
        if (publish) {
          let domain = config.publicDomainName ? config.publicDomainName : config.publicHost;
          console.log(domain + "/" + aliyunFileKey)
          resolve(domain + "/" + aliyunFileKey)
          return
        }

      },
      fail: function (err) {
        console.log(err)
        reject(err);
      },
    })
  }, (err) => {
    this.toast('获取token失败')
  });


}